export const messages = {
  en: {
    addInspectionPlan: {
      title: 'Add Plan',
      planName: 'Plan Name',
      inspectionRoute: 'Inspection Route',
      inspectionPeriod: 'Inspection Period',
      taskAdvance: 'Task Advance',
      minutesGenerate: 'minutes generate',
      month: 'Month',
      day: 'Day',
      week: 'Week',
      startDate: 'Start Date',
      endDate: 'End Date',
      startTime: 'Start Time',
      endTime: 'End Time',
      signMethod: 'Sign Method',
      allowRecheck: 'Allow Recheck',
      selectStaff: 'Select Staff',
      save: 'Save',
      back: 'Back',
      required: 'Required',
      monthlyDaily: 'Month/Day',
      weekly: 'Weekly',
      notAllowed: 'Not Allowed',
      allowed: 'Allowed',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      saveSuccess:'addInspectionPlan saveSuccess',
      saveError: 'addInspectionPlan saveError',
      inspectionPlanName:'inspection plan name',
      inspectionRouteId: 'inspection route',
      inspectionPlanPeriod: 'inspection plan period',
      signType: 'sign type',
      inspectionPlanNameRequired:'inspectionPlan name required',
      inspectionRouteRequired:'inspectionPlan route required',
      startDateRequired:'inspectionPlan startDate required',
      endDateRequired:'inspectionPlan endDate required',
      inspectionPeriodRequired:'inspectionPlan period required',
      startTimeRequired:'inspectionPlan startTime required',
      endTimeRequired:'inspectionPlan endTime required',
      signMethodRequired:'inspectionPlan signMethod required'
    }
  },
  zh: {
    addInspectionPlan: {
      title: '添加计划',
      planName: '计划名称',
      inspectionRoute: '巡检路线',
      inspectionPeriod: '巡检周期',
      taskAdvance: '任务提前',
      minutesGenerate: '分钟生成',
      month: '月',
      day: '日',
      week: '周',
      startDate: '开始日期',
      endDate: '结束日期',
      startTime: '开始时间',
      endTime: '结束时间',
      signMethod: '签到方式',
      allowRecheck: '允许补检',
      selectStaff: '选择员工',
      save: '保存',
      back: '返回',
      required: '必填',
      monthlyDaily: '月/天',
      weekly: '按周',
      notAllowed: '不允许补检',
      allowed: '允许补检',
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六',
      sunday: '星期日',
      saveSuccess: '保存成功',
      saveError: '保存失败',
      inspectionPlanName:'巡检名称',
      inspectionRouteId: '巡检路线',
      inspectionPlanPeriod: '巡检周期',
      signType: '签到方式',
      inspectionPlanNameRequired:'巡检计划名称必填',
      inspectionRouteRequired:'巡检路线必选',
      startDateRequired:'开始日期必选',
      endDateRequired:'结束日期必选',
      inspectionPeriodRequired:'巡检周期必选',
      startTimeRequired:'开始时间必选',
      endTimeRequired:'结束时间必选',
      signMethodRequired:'签到方式必选'

    }
  }
}